import moment from 'moment';
import DTO from './DTO';

class UserActionLogDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'search',
        type: String,
        validators: {},
        labelKey: 'search',
      },
      {
        name: 'causer_id',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.user',
      },
      {
        name: 'procedures',
        type: String,
        validators: {},
        labelKey: 'procedure',
      },
      {
        name: 'procedure',
        type: String,
        validators: {},
        labelKey: 'procedure',
      },
      {
        name: 'date_time',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.date_time',
      },
      {
        name: 'changes_to_object',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.changes_to_object',
      },
      {
        name: 'subject_id',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.subject_id',
      },
      {
        name: 'subject_type',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.subject_type',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.created_at',
      },
      {
        name: 'location_applicant_id',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.location_applicant_id',
      },
    ];

    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default UserActionLogDTO;
